<!-- eslint-disable max-len -->
<template>
  <div class="about-project_apt" :class="{ [curTheme]: true }">

    <page-header>
      <h1>Ошибка 404: страница не найдена</h1>
    </page-header>

    <page-text>
      <div class="text-center" style="max-width: 600px; margin: 0 auto 100px;">
        <p style="margin: 100px 0 60px;">Такой страницы не существует. Попробуйте перейти на главную страниц и произвести поиск по фразе или другим критериям.</p>
        <el-button class="vivid-button" @click="$router.replace({ path: '/' })">Перейти на главную</el-button>
      </div>
    </page-text>

    <page-footer/>
  </div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {
  components: { PageHeader, PageText, PageFooter },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layouts/Page404.vue